import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import Cookies from "js-cookie"
import { authApi, userApi } from "services/auth_api"
import { getUserProfile as fetchUserProfile } from "services/user_api"
// import { getAllUsers as fetchAllUsers } from "services/connextApi"
// import { getConnectedUsers as fetchConnectedUsers } from "services/connextApi"
// import { receivedConnectionRequest as fetchReceivedConnectionRequest } from "services/connextApi"
// import { sendConnectionRequest as apiSendConnectionRequest } from "services/connextApi"
// import { getSentConnectionRequests as fetchSentConnectionRequests } from "services/connextApi"
import { acceptConnectionRequest as apiAcceptConnectionRequest } from "services/connextApi"
import { getCurrentDeviceInfo } from "utils/helper"
import { getAllEvents } from "services/generalApi"
import { getAllServices } from "services/bazaarApi"

const initialState = {
  loading: false,
  auth: {
    user: null,
    user_id: null,
    status: "idle",
    profileCalled: false,
    on_boarding: false,
    terms_accepted: false,
    EventAccess: [],
  },
	token:localStorage.getItem("ql_token") || null,

  otherData: {},

  loadDependencies: false,
  dependency: {
    industry_dd: [],
    natureofbusiness_dd: [],
    upcomingEvents: [],
    homefeedServices: [],
  },

  loginPage: {
    input: "",
  },
  otherUserProfile: {
    data: null,
    status: "idle",
    error: null,
  },
  allUsers: {
    data: [],
    meta: {
			page : 1,
			limit : 10
    },
    status: "idle",
    error: null,
  },
  connectedUsers: {
    data: [],
    status: "idle",
    error: null,
  },
  receivedRequests: {
    data: [],
    status: "idle",
    error: null,
  },
  connectionRequest: {
    status: "idle",
    error: null,
  },
  sentRequests: {
    data: [],
    status: "idle",
    error: null,
  },
  acceptRequest: {
    status: "idle",
    error: null,
  },
  companyUpdate: {
    status: "idle",
    error: null,
  },
}

// Async thunk for accepting connection request
export const acceptConnectionRequest = createAsyncThunk(
  "auth/acceptConnectionRequest",
  async (connectionId, { rejectWithValue }) => {
    try {
			const response = await apiAcceptConnectionRequest(connectionId)
			return response
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to accept connection request."
			)
    }
  }
)

// Async thunk for login
export const login = createAsyncThunk(
  "auth/login",
  async (payload = {}, { rejectWithValue, getState, dispatch }) => {
    try {
      // Destructure with default values
      const currentDeviceInfo = await getCurrentDeviceInfo();

			const {
				resendOtp = false,
				verifyOtp = false,
				otp = "000000",
			} = payload
			const { loginPage } = getState().app

      if (!loginPage || !loginPage.input) {
				return rejectWithValue("Invalid login input")
      }

			const isNumber = /^\d+$/.test(loginPage.input)
			let credentials = {}

      const trimmedInput = loginPage?.input?.trim().toLowerCase();
      if (isNumber) {
        credentials.phone = trimmedInput;
      } else {
        credentials.email = trimmedInput;
      }
      credentials.current_device_info = currentDeviceInfo;


      if (verifyOtp) {
				credentials.otp = otp
				const response = await authApi.verify_otp(credentials)
        localStorage.setItem("user_id", response.response.id);

        if (response.status === false) {
					return rejectWithValue(response.message)
        }

				const respData = {}
				respData.verify_resp = response.response
        const expirationUnit =
					process.env.REACT_APP_TOKEN_EXPIRATION_UNIT || "hours"
        const expirationValue =
					parseInt(
						process.env.REACT_APP_TOKEN_EXPIRATION_VALUE,
						10
					) || 24
				const date = new Date()
        const multiplier =
					expirationUnit === "days"
						? 24 * 60 * 60 * 1000
						: 60 * 60 * 1000
				date.setTime(date.getTime() + expirationValue * multiplier)
				localStorage.setItem("ql_token", response.response.jwt)
        // Reset profileCalled flag and fetch profile after successful login
				dispatch(setProfileCalled(false))
        dispatch(getMyProfile())
          .unwrap()
          .catch((error) => {
            // Error handling is done in getMyProfile thunk
						console.log("Profile fetch error:", error)
					})

				return respData // Return the token on success
      } else {
        if (resendOtp) {
					credentials.resend_otp = true
        }
				const response = await authApi.login(credentials)
        if (response.status === false) {
					return rejectWithValue(response.message)
        }
				if(response.response.otp){
        }
				return response.message // Return the token on success
      }
    } catch (error) {
			return rejectWithValue("Login failed. Please try again.") // Return error message
    }
  }
)

export const getMyProfile = createAsyncThunk(
  "auth/getMyProfile",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
			const { auth, loadDependencies: load_depend } = getState().app
      if (!auth.profileCalled) {
				dispatch(setProfileCalled(true)) // Controls Multiple call of the profile page.
				const response = await authApi.myProfile()
        if (response.status === false || response.code === 4004) {
					return rejectWithValue(response.message)
        }

				if(!load_depend){
					dispatch(loadDependencies())
        }

				return response.response.profile // Return the token on success
      }
    } catch (error) {
			return rejectWithValue("Login failed. Please try again.") // Return error message
    }
  }
)

export const loadDependencies = createAsyncThunk(
  "auth/loadDependencies",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
			let RespData = {}
			const { loadDependencies } = getState().app
      if (!loadDependencies) {
				dispatch(setLoadDependencyCalled(true))
				const response = await userApi.fetchIndustries()
				RespData.industry_dd = response
        if (response.status === false) {
					return rejectWithValue(response.message)
        }

				const resp2 = await userApi.fetchNatureOfBusiness()
				RespData.natureofbusiness_dd = resp2

        if (resp2.status === false) {
					return rejectWithValue(resp2.message)
        }

				const { response : upcomingEvents} = await getAllEvents({})
				RespData.upcomingEvents = upcomingEvents?.events || []

        const hfService = await getAllServices({
          type: "buyer",
					page : 1,
          limit: 20,
          popular_services: true,
        });
				RespData.homefeedServices = hfService?.data || []
      }
			return RespData // Return the token on success
    } catch (error) {
			return rejectWithValue("Login failed. Please try again.") // Return error message
    }
  }
)

export const eventDataUpdated = createAsyncThunk(
  "event/eventDataUpdated",
  async (_, { rejectWithValue, dispatch }) => {
    try {
			const { response } = await getAllEvents({})
			const events = response?.events || []
			return events
    } catch (error) {
			dispatch(stopLoadingApp())
			return rejectWithValue("Failed to fetch upcoming events.")
    }
  }
)

export const updateProfile = createAsyncThunk(
  "auth/updateProfile",
  async (profileData, { rejectWithValue, dispatch }) => {
    try {
			dispatch(startLoadingApp())
			const response = await userApi.updateUserData(profileData)
			dispatch(stopLoadingApp())

      if (response.status === false) {
				return rejectWithValue(response.message)
      }

			return response.response
    } catch (error) {
			dispatch(stopLoadingApp())
			return rejectWithValue("Profile update failed. Please try again.")
    }
  }
)

//   export const updateCompanyDetails = createAsyncThunk(
// 	"auth/updateCompanyDetails",
// 	async ({ companyId, data }, { rejectWithValue }) => {
// 	  try {
// 		const response = await userApi.updateCompanyDetails(companyId, data);
// 		return response;
// 	  } catch (error) {
// 		return rejectWithValue(error?.response?.data?.message || "Failed to update company details.");
// 	  }
// 	}
//   );

// Async thunk for logout
export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
			await authApi.logout()
			localStorage.removeItem("ql_token") // Remove token from cookies
			return
    } catch (error) {
			return rejectWithValue(error.message)
    }
  }
)

// Async thunk to get another user's profile by ID
export const getUserProfile = createAsyncThunk(
  "auth/getUserProfile",
  async (userId, { rejectWithValue }) => {
    try {
			const response = await fetchUserProfile(userId)
			return response
    } catch (error) {
			return rejectWithValue(
				error.message || "Failed to fetch user profile."
			)
    }
  }
)

// Async thunk to get all users
// export const getAllUsers = createAsyncThunk(
// 	"auth/getAllUsers",
// 	async (_, { rejectWithValue, getState, dispatch }) => {
// 		try {
// 			const allusers = getState().app.allUsers
// 			const response = await fetchAllUsers({
// 				page: allusers?.meta?.page,
// 				limit: allusers?.meta?.limit,
// 			})

// 			return response
// 		} catch (error) {
// 			return rejectWithValue(
// 				error.message || "Failed to fetch all users."
// 			)
// 		}
// 	}
// )

// export const getConnectedUsers = createAsyncThunk(
// 	"auth/getConnectedUsers",
// 	async (_, { rejectWithValue }) => {
// 		try {
// 			const response = await fetchConnectedUsers()
// 			return response
// 		} catch (error) {
// 			return rejectWithValue(
// 				error.message || "Failed to fetch connected users."
// 			)
// 		}
// 	}
// )

// export const getReceivedConnectionRequests = createAsyncThunk(
// 	"auth/getReceivedConnectionRequests",
// 	async (_, { rejectWithValue }) => {
// 		try {
// 			const response = await fetchReceivedConnectionRequest()

// 			return response
// 		} catch (error) {
// 			if (error.response) {
// 				console.error(
// 					"Server Error:",
// 					error.response.data.message || error.response.statusText
// 				)
// 				return rejectWithValue(
// 					error.response.data.message || "Server Error"
// 				)
// 			} else if (error.request) {
// 				console.error("Network Error:", error.message)
// 				return rejectWithValue(
// 					"Network Error. Please check your connection."
// 				)
// 			} else {
// 				console.error("Error:", error.message)
// 				return rejectWithValue(
// 					"An unexpected error occurred. Please try again."
// 				)
// 			}
// 		}
// 	}
// )

// export const getSentConnectionRequests = createAsyncThunk(
// 	"auth/getSentConnectionRequests",
// 	async (page = 1, { rejectWithValue }) => {
// 		try {
// 			const response = await fetchSentConnectionRequests(page)
// 			return response
// 		} catch (error) {
// 			if (error.response) {
// 				console.error(
// 					"Server Error:",
// 					error.response.data.message || error.response.statusText
// 				)
// 				return rejectWithValue(
// 					error.response.data.message || "Server Error"
// 				)
// 			} else if (error.request) {
// 				console.error("Network Error:", error.message)
// 				return rejectWithValue(
// 					"Network Error. Please check your connection."
// 				)
// 			} else {
// 				console.error("Error:", error.message)
// 				return rejectWithValue(
// 					"An unexpected error occurred. Please try again."
// 				)
// 			}
// 		}
// 	}
// )

// export const sendConnectionRequest = createAsyncThunk(
// 	"auth/sendConnectionRequest",
// 	async (recipientId, { rejectWithValue }) => {
// 		try {
// 			const response = await apiSendConnectionRequest(recipientId)
// 			return response
// 		} catch (error) {
// 			return rejectWithValue(
// 				error.message || "Failed to send connection request."
// 			)
// 		}
// 	}
// )

// App slice
const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setInput: (state, action) => {
			state.loginPage.input = action.payload
    },

    setProfileCalled: (state, action) => {
			state.auth.profileCalled = action.payload
    },
    setTermsAccepted: (state, action) => {
			state.auth.terms_accepted = action.payload
    },

    setLoadDependencyCalled: (state, action) => {
			state.loadDependencies = action.payload
    },

    startLoadingApp: (state, action) => {
			state.loading = true
    },
    stopLoadingApp: (state, action) => {
			state.loading = false
    },

    updateUser: (state, action) => {
      state.auth.user = {
        ...state.auth.user,
        ...action.payload,
      };
    },
    updatePostCount: (state, action) => {
      state.auth.user.postCount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
				state.loading = true
      })
      .addCase(login.fulfilled, (state, action) => {
				state.loading = false
        if (action.payload?.verify_resp?.jwt) {
					state.token = action.payload.verify_resp.jwt
					state.auth.on_boarding =action.payload.verify_resp.on_boarding
					state.auth.terms_accepted=action.payload.verify_resp.terms_agreed
					state.auth.profileCalled = false // Reset to allow profile fetch after login
        }
      })
      .addCase(login.rejected, (state) => {
				state.loading = false
      })

      .addCase(getMyProfile.pending, (state) => {
				state.loading = true
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
				state.auth.user = action.payload
				state.auth.on_boarding = action.payload?.on_boarding
				state.auth.terms_accepted=action.payload?.terms_agreed

				let bb_ref_data = action.payload?.bubble_ref_data
        let EventAccess = [];
        if (bb_ref_data && typeof bb_ref_data === "object") {
          EventAccess = Object.entries(bb_ref_data)
            .filter(
              ([key, value]) =>
                typeof key === "string" &&
                key.endsWith("Status") &&
                value === "ongoing"
            )
            .map(([key]) => key.replace(" Status", ""))
            .filter(Boolean);
        }

				state.auth.EventAccess = EventAccess

				state.loading = false
      })
      .addCase(getMyProfile.rejected, (state) => {
				state.loading = false
      })

      .addCase(loadDependencies.pending, (state) => {
				state.loading = true
      })
      .addCase(loadDependencies.fulfilled, (state, action) => {
				state.dependency.industry_dd = action.payload.industry_dd
				state.dependency.natureofbusiness_dd = action.payload.natureofbusiness_dd
				state.dependency.upcomingEvents = action.payload.upcomingEvents
				state.dependency.homefeedServices = action.payload.homefeedServices
				state.loading = false
      })
      .addCase(loadDependencies.rejected, (state) => {
				state.loading = false
      })

      .addCase(eventDataUpdated.pending, (state) => {
				state.loading = true
      })
      .addCase(eventDataUpdated.fulfilled, (state, action) => {
				state.dependency.upcomingEvents = action.payload
				state.loading = false
      })
      .addCase(eventDataUpdated.rejected, (state) => {
				state.loading = false
      })

      .addCase(logout.pending, (state) => {
				state.loading = true
      })
      .addCase(logout.fulfilled, (state) => {
				state.loading = false
				state.auth.user = null
				state.auth.user_id = null
				state.auth.profileCalled = false
				state.auth.status = "idle"
				state.auth.on_boarding = false
				state.auth.terms_accepted = false
				state.auth.EventAccess = []
				state.token = null
				state.loadDependencies = false
      })
      .addCase(logout.rejected, (state) => {
				state.loading = false
      })
      .addCase(updateProfile.pending, (state) => {
				state.loading = true
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
				state.loading = false
        state.auth.user = {
          ...state.auth.user,
          ...action.payload,
				}
      })
      .addCase(updateProfile.rejected, (state, action) => {
				state.loading = false
				console.error("Profile update failed:", action.payload)
      })
      // For getUserProfile
      .addCase(getUserProfile.pending, (state) => {
				state.otherUserProfile.status = "loading"
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
				state.otherUserProfile.data = action.payload
				state.otherUserProfile.status = "succeeded"
      })
      .addCase(getUserProfile.rejected, (state, action) => {
				state.otherUserProfile.status = "failed"
				state.otherUserProfile.error = action.payload
			})

    // .addCase(getAllUsers.pending, (state) => {
    // 	state.allUsers.status = "loading"
    // })
    // .addCase(getAllUsers.fulfilled, (state, action) => {
    // 	state.allUsers.data = action.payload
    // 	state.allUsers.status = "succeeded"
    // })
    // .addCase(getAllUsers.rejected, (state, action) => {
    // 	state.allUsers.status = "failed"
    // 	state.allUsers.error = action.payload
    // })
    // .addCase(getConnectedUsers.pending, (state) => {
    // 	state.connectedUsers.status = "loading"
    // })
    // .addCase(getConnectedUsers.fulfilled, (state, action) => {
    // 	state.connectedUsers.data = action.payload
    // 	state.connectedUsers.status = "succeeded"
    // })
    // .addCase(getConnectedUsers.rejected, (state, action) => {
    // 	state.connectedUsers.status = "failed"
    // 	state.connectedUsers.error = action.payload
    // })
    // .addCase(getReceivedConnectionRequests.pending, (state) => {
    // 	state.receivedRequests.status = "loading"
    // })
    // .addCase(
    // 	getReceivedConnectionRequests.fulfilled,
    // 	(state, action) => {
    // 		state.receivedRequests.data = Array.isArray(action.payload)
    // 			? action.payload
    // 			: []
    // 		state.receivedRequests.status = "succeeded"
    // 	}
    // )

    // .addCase(
    // 	getReceivedConnectionRequests.rejected,
    // 	(state, action) => {
    // 		state.receivedRequests.status = "failed"
    // 		state.receivedRequests.error = action.payload
    // 	}
    // )
    // .addCase(sendConnectionRequest.pending, (state) => {
    // 	state.connectionRequest.status = "loading"
    // })
    // .addCase(sendConnectionRequest.fulfilled, (state, action) => {
    // 	state.connectionRequest.status = "succeeded"
    // 	// Optional: Add any success message or status update
    // })
    // .addCase(sendConnectionRequest.rejected, (state, action) => {
    // 	state.connectionRequest.status = "failed"
    // 	state.connectionRequest.error = action.payload
    // })
    // .addCase(getSentConnectionRequests.pending, (state) => {
    // 	state.sentRequests.status = "loading"
    // })
    // .addCase(getSentConnectionRequests.fulfilled, (state, action) => {
    // 	state.sentRequests.data = action.payload
    // 	state.sentRequests.status = "succeeded"
    // })
    // .addCase(getSentConnectionRequests.rejected, (state, action) => {
    // 	state.sentRequests.status = "failed"
    // 	state.sentRequests.error = action.payload
    // })
    // .addCase(acceptConnectionRequest.pending, (state) => {
    // 	state.acceptRequest.status = "loading"
    // })
    // .addCase(acceptConnectionRequest.fulfilled, (state, action) => {
    // 	state.acceptRequest.status = "succeeded"
    // 	// Optional: Update receivedRequests list to reflect the accepted connection
    // 	state.receivedRequests.data =
    // 		state.receivedRequests.data.filter(
    // 			(request) => request.id !== action.meta.arg
    // 		)
    // })
    // .addCase(acceptConnectionRequest.rejected, (state, action) => {
    // 	state.acceptRequest.status = "failed"
    // 	state.acceptRequest.error = action.payload
    // })

    // 			  .addCase(updateCompanyDetails.pending, (state) => {
    //   state.companyUpdate.status = "loading";
    // })
    // .addCase(updateCompanyDetails.fulfilled, (state, action) => {
    //   state.companyUpdate.status = "succeeded";
    //   // Optional: Update company data in the state if needed
    //   // state.auth.user.company = action.payload;
    // })
    // .addCase(updateCompanyDetails.rejected, (state, action) => {
    //   state.companyUpdate.status = "failed";
    //   state.companyUpdate.error = action.payload;
    // });

    // Other existing reducers...
  },
});

export const {
  setInput,
  setProfileCalled,
  setLoadDependencyCalled,
  startLoadingApp,
  stopLoadingApp,
  setTermsAccepted,
  updateUser,
  updatePostCount,
} = appSlice.actions;

export default appSlice.reducer;
